/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AccessibleMCPServer,
  AccessibleMCPServer$inboundSchema,
} from "./accessiblemcpserver.js";
import {
  AccessibleSkill,
  AccessibleSkill$inboundSchema,
} from "./accessibleskill.js";

export type ListIdentityAccessResult = {
  /**
   * MCP servers accessible to this identity.
   */
  servers: Array<AccessibleMCPServer>;
  /**
   * Skills accessible to this identity.
   */
  skills: Array<AccessibleSkill>;
};

/** @internal */
export const ListIdentityAccessResult$inboundSchema: z.ZodMiniType<
  ListIdentityAccessResult,
  unknown
> = z.object({
  servers: z.array(AccessibleMCPServer$inboundSchema),
  skills: z.array(AccessibleSkill$inboundSchema),
});

export function listIdentityAccessResultFromJSON(
  jsonString: string,
): SafeParseResult<ListIdentityAccessResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIdentityAccessResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIdentityAccessResult' from JSON`,
  );
}
